import script from "./ADialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ADialog.vue?vue&type=script&lang=ts&setup=true"

import "./ADialog.vue?vue&type=style&index=0&id=7fd0bf80&lang=scss"

const __exports__ = script;

export default __exports__